import React, { useState, useEffect } from 'react';
import Layout from '../../core/Layout';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabPane from 'react-bootstrap/TabPane';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import TabContainer from 'react-bootstrap/TabContainer';
import { useLocation, Link } from 'react-router-dom';
import { getActiveTrades, newMessageFalse } from '../apiUser';
import { isAuthenticated } from '../../auth';
import { CheckCircleIcon, ChevronRightIcon, MailIcon, RefreshIcon, ChatIcon } from '@heroicons/react/solid'


//TODO; dont save user info into trade data, instead just fetch it striaght from the user object IDS

const Trades = () => {
    const [trades, setTrades] = useState([]);
    const [error, setError] = useState('');

    const [otherUser, setOtherUser] = useState({});

    const [activeTab, setActiveTab] = useState(0);
    const [tabs, setTabs] = useState([]);

    const { user: {_id}, token } = isAuthenticated();

    const init = () => {
        getActiveTrades(_id, token).then(data => {
            if (data.error) {
                setError(data.error);
            }
            else {
                setTrades(data);
            }
        });
    };

    useEffect(() => {
        init();
    },[]);

    const BadgeCondition = ({status}) => {
        if (status === 'pending') {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Pending
                </span>
            );
        }
        else if (status === 'accepted') {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Accepted
                </span>
            );
        }
        else if (status === 'canceled') {
            return (
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                    Canceled
                </span>
            );
        }
        else {
            return (<></>);
        }
    };


    return (
        <Layout
            className='lg:px-40 md:px-20 py-8 sm:px-3'
        >
            <div className="bg-white shadow overflow-hidden sm:rounded-md ">
                <ul className="divide-y divide-gray-200">
                    {trades.map((trade, i) => (
                        <li key={i}>
                            <a href={`/trade/${trade._id}`} className="block hover:bg-gray-50">
                                <div className="flex items-center px-4 py-4 sm:px-6">
                                    <div className="min-w-0 flex-1 flex items-center">
                                        <div className="flex-shrink-0">
                                            { trade.reciever === _id ?
                                                <img className="h-12 w-12 rounded-full" src={trade.senderProfilePicture} alt="" />
                                                :

                                                <img className="h-12 w-12 rounded-full" src={trade.recieverProfilePicture} alt="" />
                                            }
                                        </div>
                                        <div className="min-w-0 flex-1 px-4 md:grid md:grid-cols-2 md:gap-4">
                                            <div>
                                                { trade.reciever === _id ?
                                                    <>
                                                        <p className="text-sm font-medium text-indigo-600 truncate">{trade.senderName}</p>
                                                        <BadgeCondition status={trade.status}/> 
                                                        
                                                    </>
                                                    :
                                                    <>
                                                        <p className="text-sm font-medium text-indigo-600 truncate">{trade.recieverName}</p>
                                                        <BadgeCondition status={trade.status}/> 
                                                    </>
                                                }
                                                <p className="mt-2 items-center text-sm text-gray-500">
                                                    <span className='flex truncate'>{trade.recieverItemName} <RefreshIcon className='h-5 w-5 mx-2'/>
                                                        {trade.senderItemsNames.map((senderItemName, i) => (
                                                            <>
                                                                {senderItemName}{i !== trade.senderItemsNames.length-1 ? ', ' :''}
                                                            </>
                                                        ))}
                                                    </span>
                                                </p>
                                            </div>
                                            <div className="md:block">
                                                { trade.reciever === _id ?
                                                    <div>
                                                        {trade.recieverNewMessage &&
                                                        <p className="text-sm text-gray-900">
                                                            New Message!
                                                            <ChatIcon className='flex-shrink-0 h-5 w-5 text-red-400' />
                                                        </p>
                                                        }
                                                        <p className="mt-2 flex items-center text-sm text-gray-500">
                                                        </p>
                                                    </div>
                                                    :
                                                    <div>
                                                        {trade.senderNewMessage &&
                                                        <p className="text-sm text-gray-900">
                                                            New Message!
                                                            <ChatIcon className='flex-shrink-0 h-5 w-5 text-red-400' />
                                                        </p>
                                                        }
                                                        <p className="mt-2 flex items-center text-sm text-gray-500">
                                                        </p>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <ChevronRightIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                </div>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </Layout>
    );

};

export default Trades;
